export const DOCKED_EXPAND_ANIMATION_MS = 400
